import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { PgModalService } from 'pg-lib/pg-ui-elements/pg-modal.service';
import { EnvironmentService } from 'pg-lib/services/environment.service';
import { LocalizationService } from 'pg-lib/services/localization.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-totem-header',
    templateUrl: './totem-header.component.html',
    styleUrls: ['./totem-header.component.scss'],
    standalone: false
})
export class TotemHeaderComponent implements OnInit, OnDestroy {

    constructor(private localizationService:LocalizationService, private environmentService:EnvironmentService, private modalService:PgModalService) { }

    @Input() configData:any;

    languageOptions:Array<{ value: string, text: string }> = null;
    currentLanguage:string = null;

    totemTitleFormatted:string = null;

    private _availableLanguagesSubscription:Subscription = null;

    ngOnInit(): void {
        this._refreshLanguageOptions();

        this.currentLanguage = this.localizationService.currentLanguage;

        this._availableLanguagesSubscription = this.localizationService.availableLanguagesChange.subscribe(() => {
            this._refreshLanguageOptions();
        })

        this.totemTitleFormatted = this.localizationService.translate(this.configData.title)
        if(!/</.test(this.totemTitleFormatted)) {
            this.totemTitleFormatted = '<h2>' + this.configData.title + '</h2>'
        }
    }

    ngOnDestroy(): void {
        this._availableLanguagesSubscription?.unsubscribe();
    }

    private _refreshLanguageOptions() {
        this.languageOptions = [];

        for(let _language of this.localizationService.availableApplicationLanguages) {
            this.languageOptions.push({ value: _language, text: this.getLanguageLabel(_language) })
        }
    }

    setLanguage(language:string) {
        if(language != this.currentLanguage) {
            this.currentLanguage = language;
            this.localizationService.setLanguage(language);
        }
    }

    getLanguageLabel(language:string) {
        return this.localizationService.languageLabels[language] || language
    }

    showVersions() {
        this.modalService.alert(
            this.localizationService.translate('totem-header.versions-title'),
            this.environmentService.getVersionsTable() || this.localizationService.translate('totem-header.versions-empty'),
        );
    }
}
